var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundAddButtoninline = function SvgRoundAddButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "current",
    stroke: "transparent",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M20.5 15.5h-11v-1h11z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M14.5 20.5v-11h1v11z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M20.5 15.5h-11v-1h11z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M14.5 20.5v-11h1v11z",
    clipRule: "evenodd"
  })));
};
export default SvgRoundAddButtoninline;